import { Component } from 'react';
import FacebookButton from 'react-facebook-login';
import { connect } from 'react-redux';

import { fbLoginOrCreate } from 'redux/customer/actions';

class FacebookLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: null
    };
  }

  handleFacebookLogin = (fbProfile) => {
    const { props } = this;
    const errorFunction = () => {
      this.setState({ showMessage: 'Error' });
    };
    const successFunction = () => {
      const { onRedirect } = this.props;
      onRedirect();
    };
    props.fbLoginOrCreate(
      fbProfile.accessToken,
      successFunction,
      errorFunction
    );
  };

  render() {
    const { showMessage } = this.state;
    const { appId } = this.props;
    return (
      <>
        {showMessage === 'Error' && (
          <div className="c7-message--error">Error: Invalid Facebook Login</div>
        )}
        <FacebookButton
          appId={appId}
          autoLoad={false}
          callback={this.handleFacebookLogin}
          fields="name,email,picture,first_name,last_name"
          scope="public_profile,email"
          textButton="Continue with Facebook"
          cssClass="c7-icon c7-icon--facebook"
          disableMobileRedirect
        />
      </>
    );
  }
}

export default connect(null, { fbLoginOrCreate })(FacebookLogin);
